import { Box } from '@mui/material';

import { ReactComponent as Facebook } from '@/icons/facebook.svg';
import { ReactComponent as Instagram } from '@/icons/instagram.svg';
import { ReactComponent as Spotify } from '@/icons/spotify.svg';
import { ReactComponent as Tiktok } from '@/icons/tiktok.svg';
import { ReactComponent as YouTube } from '@/icons/youtube.svg';

export default function SocialLinks() {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 3,
        justifyContent: 'center',
        marginTop: '24px',
      }}
    >
      <a
        href="https://www.facebook.com/Odrabiamypl"
        aria-label="Odrabiamy.pl na Facebooku"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Facebook />
      </a>
      <a
        href="https://www.instagram.com/odrabiamy.pl"
        aria-label="Odrabiamy.pl na Instagramie"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Instagram />
      </a>
      <a
        href="https://www.youtube.com/channel/UCGd8omo2yT7qUqT-c4JX9aQ"
        aria-label="Odrabiamy.pl na YouTube"
        target="_blank"
        rel="noopener noreferrer"
      >
        <YouTube />
      </a>
      <a
        href="https://www.tiktok.com/@odrabia.my"
        aria-label="Odrabiamy.pl na TikToku"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Tiktok />
      </a>
      <a
        href="https://open.spotify.com/show/0KoRlhmnzWYSWqKqKwr8fr"
        aria-label="Odrabiamy.pl na TikToku"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Spotify />
      </a>
    </Box>
  );
}
